import { v4 as uuidv4 } from "uuid";

import {
  materials,
  transport,
  energy,
  // gas,
  ENERGY_INUSE_FACTOR,
} from "./factors";

const calculate_a1 = ({
  data: {
    details: {
      moduleSubmissions: { a1 },
    },
    totals,
  },
}) => {
  for (const materialInput of a1) {
    // lookup materialInputs material
    const material = materials.find((m) => m.name === materialInput.material);
    if (!materialInput.$id) {
      materialInput.$id = uuidv4();
    }
    if (material) {
      materialInput.default_emission_factor = material.factor;
      // Calculate materialInput emissions if we have mass
      if (materialInput.mass) {
        // Check if there's a supplier emission factor
        materialInput.factor = materialInput.supplier_emission_factor
          ? materialInput.supplier_emission_factor
          : material?.factor;
        materialInput.kgCO2e = materialInput.mass * materialInput.factor;
        totals.a1 += materialInput.kgCO2e;
        totals.assigned_mass += Number(materialInput.mass);
      }
    }
  }
};

const calculate_a2 = ({
  data: {
    details: {
      moduleSubmissions: { a1, a2 },
    },
    totals,
  },
}) => {
  for (const delivery of a2) {
    const { distance, mode, item } = delivery;
    if (Number.isFinite(Number(item)) && mode && distance) {
      const transportMode = transport?.find((t) => t.name === mode);
      const materialEntry = a1[item];
      if (materialEntry && transportMode) {
        delivery.kgCO2e = materialEntry.mass * distance * transportMode.factor;
        totals.a2 += delivery.kgCO2e;
      }
    }
  }
};

const calculate_a3 = ({
  data: {
    details: {
      moduleSubmissions: { a3 },
    },
    totals,
  },
}) => {
  for (const energyInput of a3) {
    // look up source
    const source = energy.find((e) => e.name == energyInput.source);
    if (source) {
      energyInput.unit = source.unit;
      energyInput.default_emission_factor = source.factor;
      energyInput.factor = energyInput.supplier_emission_factor
        ? energyInput.supplier_emission_factor
        : source.factor;
      energyInput.kgCO2e = energyInput.factor * energyInput.value;
      totals.a3 += energyInput.kgCO2e;
    }
  }
};

const calculate_a4 = ({
  data: {
    details: {
      moduleSubmissions: { a4 },
      mass,
    },
    totals,
  },
}) => {
  for (const leg of a4) {
    // look up mode
    const mode = transport?.find((m) => m.name === leg.mode);
    if (mode) {
      leg.kgCO2e = mode.factor * leg.distance * mass;
      totals.a4 += leg.kgCO2e;
    }
  }
};

const calculate_b8 = ({
  data: {
    details: {
      moduleSubmissions: { b8 },
    },
    totals,
  },
}) => {
  if (b8.mass && b8.leak_rate) {
    b8.leak_mass = b8.mass * b8.leak_rate;
  }
  if (b8.lifetime && b8.leak_mass && b8.gwp) {
    b8.total_kgco2e_lifetime = b8.leak_mass * b8.gwp * b8.lifetime;
  }
  if (b8.annual_losses && b8.lifetime) {
    b8.total_kgco2e_lifetime +=
      b8.annual_losses * ENERGY_INUSE_FACTOR * b8.lifetime;
    totals.b8 = b8.total_kgco2e_lifetime;
  }
};

export const calculateFields = ({ data }) => {
  console.log(data, "calculateFieldsData");
  data.totals = {
    a1: 0,
    a2: 0,
    a3: 0,
    a4: 0,
    b8: 0,
    assigned_mass: 0,
    subtotal: 0,
    total: 0,
  };
  for (const calculation of [
    calculate_a1,
    calculate_a2,
    calculate_a3,
    calculate_a4,
    calculate_b8,
  ])
    calculation({ data });

  data.totals.subtotal =
    data.totals.a1 + data.totals.a2 + data.totals.a3 + data.totals.a4;
  data.totals.total = data.totals.subtotal + data.totals.b8;
  return data;
};
